import React, {ReactNode} from "react";
import {Dialog} from "primereact/dialog";
import {Button} from "primereact/button";
import AbstractDialog, {
	AbstractDialogProperties,
	AbstractDialogState
} from "../../../shared/dialog/components/AbstractDialog";
import Translate from "../../../shared/translation/Translate";
import Icon from "../../../shared/components/Icon";

export interface AdminDebugGlobals {
}

export function initAdminDebugGlobals(): AdminDebugGlobals {
	return {};
}

interface AdminDebugDialogProperties extends AbstractDialogProperties, AdminDebugGlobals {
}

export class AdminDebugDialogDefinition extends AbstractDialog<AdminDebugDialogProperties, AbstractDialogState> {
	/**
	 * render component as react node
	 */
	public renderDialog(): ReactNode {
		let classList: Array<string> = ["debug-dialog"];
		if (this.state.submitted) {
			classList.push("submitted");
		}

		return (
			<Dialog className={classList.join(" ")} visible={this.props.visible} onHide={this.hide}
					closeOnEscape={true} header={this.renderHeader()} footer={this.renderFooter()} resizable={false}
					appendTo={document.getElementById("root")}>
				<p>no entries yet</p>
			</Dialog>
		);
	}

	/**
	 * Render the dialog header
	 */
	protected renderHeader(): ReactNode {
		return (
			<div>
				<h1>
					<Icon icon={"icon-bug"}/>
					<Translate {...this.props} data="debug.title" namespace="dialog"/>
				</h1>
				<Button icon="icon icon-close" onClick={() => this.hide()}/>
			</div>
		);
	}

	/**
	 * Render the dialog footer
	 */
	protected renderFooter(): ReactNode {
		return (
			<div>
				<Button label={Translate.value("buttons.close")} icon="icon icon-close"
						onClick={() => this.hide()} className="dialog-button"/>
			</div>
		);
	}

	protected isValid(): boolean {
		if (!this.mounted || !this.props.visible) {
			return false;
		}

		return !this.state.submitted;
	}
}

const AdminDebugDialog = React.memo(AdminDebugDialogDefinition,
	(prevProps: Readonly<AdminDebugDialogProperties>, nextProps: Readonly<AdminDebugDialogProperties>) => {
		if (!nextProps.visible && !prevProps.visible) {
			return true
		}

		return false;
	}
);

export default AdminDebugDialog;